import { render, staticRenderFns } from "./Addpage-AW.vue?vue&type=template&id=0ea7deef&scoped=true"
import script from "./Addpage-AW.vue?vue&type=script&lang=js"
export * from "./Addpage-AW.vue?vue&type=script&lang=js"
import style0 from "./Addpage-AW.vue?vue&type=style&index=0&id=0ea7deef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea7deef",
  null
  
)

export default component.exports